<script setup>
	
</script>

<template>
	<div id="acceptanceBannerWrapper">
		<div id="acceptanceBanner">
			<span>{{ $t('acceptance.test') }}</span>
			<span>{{ $t('acceptance.noTreatment') }}</span>
		</div>
	</div>
</template>

<style scoped>
	#acceptanceBannerWrapper {
		position: relative;
		@media screen and (max-width: 859px){
			min-height: 80px;
		}
		@media screen and (min-width: 860px){
			min-height: 40px;
		}

		#acceptanceBanner {
			display: flex !important;
			align-items: center;
			justify-content: center;
			color: #fff;
			background: #f00;
			padding: 0.25em;
			font-size: 1.2rem;
			position: fixed; 
			top: 0;
			right: 0; left: 0;
			z-index: 90000;

			@media screen and (max-width: 859px){
				flex-direction: column;
				gap: 0.25em;
				height: 80px;
				font-size: 16px;
			}
			@media screen and (min-width: 860px){
				flex-direction: row;
				gap: 2em;
				height: 40px;
			}
		}
	}
</style>